import {API} from '../../../networking/http'
import {BookingStateParticipant} from '../../../services/booking/forms/types'
import {normaliseValidatedSubscriptions, ValidatedUserSubscriptions} from '../helpers'
import {Subscription, UnavailableSubscription} from '../types'

type ServiceBasedOption = {
  start?: number
  end?: number
  areaId?: string
  sportId?: string | null
  teacherId?: string | null
}

type ClassBasedOption = {
  slotId?: string
  classId?: string | null
}

export type Option = ClassBasedOption &
  ServiceBasedOption & {
    venueId?: string
    userId?: string
    date?: string
    participants?: BookingStateParticipant[]
    useForParticipants?: boolean
    duration?: number | string
    timeSlot?: number
    bookingType?: string
    consideredDate?: string
    sportType?: string
    isConsideredOption?: boolean
  }

export type ValidateUserSubscriptionsMutationParams = {
  options: Option[]
}
// What the endpoint sends: a bare array, or (with includeUnavailable) memberships + unavailable.
type ValidateUserSubscriptionsRawResponse = Subscription[] | {memberships: Subscription[]; unavailable: UnavailableSubscription[]}
// What callers get: always the same shape, whichever one the server answered.
export type ValidateUserSubscriptionsMutationReturnType = ValidatedUserSubscriptions

export const makeValidateUserSubscriptionsEndpoint = () => 'bookings/validate/byUser'

export const validateUserSubscriptionsMutation = () => ({
  mutationFn: (user: ValidateUserSubscriptionsMutationParams) =>
    API.post<ValidateUserSubscriptionsMutationParams & {includeUnavailable: boolean}, ValidateUserSubscriptionsRawResponse>(
      makeValidateUserSubscriptionsEndpoint(),
      // Opt in to passes that exist but are outside their hours, so the person is told why they are missing.
      {...user, includeUnavailable: true},
    ).then((res) => normaliseValidatedSubscriptions(res.data)),
})
